export function setCookie(cname, cvalue, exdays) {
  let cookie = `${cname}=${cvalue};path=/`;

  if (exdays != null) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    cookie += `;expires=${d.toUTCString()}`;
  }

  document.cookie = cookie;
}

export function getCookie(cname) {
  let name = cname + '=';
  let ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  // eslint-disable-next-line quotes
  return '';
}

export function removeCookie(cname) {
  document.cookie = cname + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
}

export function clearAllCookies() {
  document.cookie.split(';').forEach(cookie => {
    const name = cookie.split('=')[0].trim();
    if (name) removeCookie(name);
  });
}
